import http from "./http";

const getRate = (params, cancelToken) => {
  return http.get("/admin/rates", {
    params,
    cancelToken,
  });
};

const getRateByOne = (params) => {
  return http.get(`/admin/rates/${params}`);
};

const createRate = (data) => {
  return http.post("/admin/rates", data);
};

const getListRateByCustomer = (params) => {
  return http.get(`/admin/rates/customer/${params}`);
};

export default {
  getRate,
  createRate,
  getRateByOne,
  getListRateByCustomer,
};
